import {api, currentWorkspace} from "./host";

// «Smart forms» — the module's only door to the server (zofino-strapi src/modules/forms).
const ws = () => ({workspace: currentWorkspace()});
const data = (response) => response?.data?.data;
const quiet = {suppressGlobalErrorHandler: true};

export const formsApi = {
    access: () => api.get("/smart-forms/access", {headers: ws(), ...quiet}).then(data),
    options: () => api.get("/smart-forms/options", {headers: ws()}).then(data),
    taskSources: () => api.get("/smart-forms/task-sources", {headers: ws(), ...quiet}).then(data),
    list: (params) => api.get("/smart-forms", {headers: ws(), params}).then(data),
    create: (body) => api.post("/smart-forms", body, {headers: ws()}).then(data),
    get: (key) => api.get(`/smart-forms/${key}`, {headers: ws()}).then(data),
    saveDraft: (key, draft, revision) => api.put(`/smart-forms/${key}/draft`, {draft, revision}, {headers: ws(), ...quiet}).then(data),
    validate: (key) => api.get(`/smart-forms/${key}/validate`, {headers: ws()}).then(data),
    publish: (key, changeNote) => api.post(`/smart-forms/${key}/publish`, {changeNote}, {headers: ws(), ...quiet}).then(data),
    status: (key, action) => api.post(`/smart-forms/${key}/status`, {action}, {headers: ws()}).then(data),
    rotateLink: (key) => api.post(`/smart-forms/${key}/rotate-link`, {}, {headers: ws()}).then(data),
    test: (key, answers) => api.post(`/smart-forms/${key}/test`, {answers}, {headers: ws(), ...quiet}).then(data),
    analytics: (key) => api.get(`/smart-forms/${key}/analytics`, {headers: ws()}).then(data),
    submissions: (params) => api.get("/smart-forms/submissions", {headers: ws(), params}).then(data),
    submission: (key) => api.get(`/smart-forms/submissions/${key}`, {headers: ws()}).then(data),
    resolveIdentity: (key, decision) => api.post(`/smart-forms/submissions/${key}/identity`, {decision}, {headers: ws()}).then(data),
    retry: (key) => api.post(`/smart-forms/submissions/${key}/retry`, {}, {headers: ws()}).then(data),
    review: (key, body) => api.post(`/smart-forms/submissions/${key}/review`, body, {headers: ws()}).then(data),
    exportCsv: (params) => api.get("/smart-forms/submissions/export", {headers: ws(), params, responseType: "blob"}).then((response) => ({
        blob: response.data,
        rows: Number(response.headers?.["x-export-rows"] || 0),
        filename: /filename="([^"]+)"/.exec(response.headers?.["content-disposition"] || "")?.[1] || "form-responses.csv",
    })),
    // respondent side: no sign-in, no workspace
    publicForm: (token) => api.get(`/public-forms/${token}`, quiet).then(data),
    publicSubmit: (token, body) => api.post(`/public-forms/${token}/submissions`, body, quiet).then(data),
    publicUpload: (token, field, file) => {
        const form = new FormData();
        form.append("field", field);
        form.append("file", file);
        return api.post(`/public-forms/${token}/files`, form, quiet).then(data);
    },
};

// the translation key of a server error («forms.error.plan-required» is already a key; unknown ones get a generic one)
const KNOWN = new Set([
    "plan-required", "manage-required", "read-required", "not-found", "revision-conflict", "publish-invalid", "project-missing",
    "validation", "not-accepting", "link-invalid", "rate-limited", "file-too-large", "file-type", "file-invalid", "storage-full", "archived", "not-published",
    "draft-too-large", "candidate-invalid", "test-no-actions", "submission-not-found", "template-not-found",
]);
export function formsErrorKey(error, fallback = "forms.error.generic") {
    const message = String(error?.response?.data?.error?.message || "");
    const name = message.startsWith("forms.error.") ? message.slice("forms.error.".length) : "";
    return KNOWN.has(name) ? message : fallback;
}
export const formsErrorDetails = (error) => error?.response?.data?.error?.details || {};

// a field error from the engine or the server ({code, n}) as text
export const fieldErrorText = (t, error) => (error ? t(`forms.validation.${error.code || "invalid"}`, {n: error.n}) : "");
